import React from 'react';
import { activityHelper } from '../helpers/user-activity-helper';

export const SSOFormContext = React.createContext();
activityHelper.handleUserIdleTime();
activityHelper.refreshMyAccountStyle();

export function withSSOFormContext(Component) {
    // eslint-disable-next-line react/display-name
    return (props) => (
        <SSOFormContext.Consumer>
            {(context) => <Component {...props} sso={context} />}
        </SSOFormContext.Consumer>
    );
}
